import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import sanityClient from "../client.js";
import SanityBlockContent from "@sanity/block-content-to-react";
import { Helmet } from "react-helmet"; 
import "../css/SinglePost.css";

export default function SinglePost() {
    const [singlePost, setSinglePost] = useState(null);
    const { slug } = useParams();

    useEffect(() => {
        sanityClient.fetch(`*[slug.current == "${slug}"]{
            title,
            _id,
            slug,
            mainImage{
                asset->{
                    _id,
                    url,
                },
            },
            body,
            "authorName": author->name,
            "authorImage": author->image,
            publishedAt
        }`).then((data) => {setSinglePost(data[0]); console.log(data[0].mainImage.asset.url)})
        .catch(console.error);
    }, [slug]);

    if (!singlePost) return <div>Loading...</div>;

    const postUrl = `${window.location.origin}/posts/${slug}`;
    const formattedDate = new Date(singlePost.publishedAt).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    return (
        <main className="single-post-body">
            {/* Add Open Graph Meta Tags */}
            
            <Helmet>
                <title>{singlePost.title}</title>
                <meta property="og:url" content={postUrl} />
                <meta property="og:type" content="article" />
                <meta property="og:title" content={singlePost.title} />
                <meta property="og:description" content={singlePost.title} />
                <meta property="og:image" content={singlePost.mainImage.asset.url} />
                <meta property="og:image:alt" content={singlePost.title} />
            </Helmet>

            <article>
                <header>
                    <img
                        className="single-post-image"
                        src={singlePost.mainImage.asset.url}
                        alt={singlePost.title}
                    />
                </header>
                <div className="single-post-container">
                    <date>{formattedDate}</date>
                    <div className="single-post-content">
                        <SanityBlockContent
                            blocks={singlePost.body}
                            projectId="066s3bew"
                            dataset="production"
                        />
                    </div>
                </div>

                <div className="social-share">
              
                    <a
                        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(postUrl)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="share-button facebook"
                        >
                        Share on Facebook
                    </a>
                    <a
                        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(postUrl)}&text=${encodeURIComponent(singlePost.title)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="share-button twitter"
                    >
                        Share on Twitter
                    </a>
                    <a
                        href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(postUrl)}&title=${encodeURIComponent(singlePost.title)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="share-button linkedin"
                    >
                        Share on LinkedIn
                    </a>
                </div>
            </article>
        </main>
    );
}
